import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'mn',
    fullName: 'Mongolian',
    nativeName: 'Монгол',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Гайхалтай зүйл ирж байна",
    landing_subtitle: "ArgVoid бол програм, тоглоом хөгжүүлэх студи юм. Хамтран байгаарай, удахгүй шинэ зүйлс гарах болно!",
    select_language: "Хэл сонгоно уу",
    search_placeholder: "Хэл хайх...",
    terms_title: "Үйлчилгээний нөхцөл",
    policy_title: "Нууцлалын бодлого",
    cookies_title: "Күүкийн бодлого",
    terms_content: `
        <strong>1. </strong><br> нөхцөлийг хүлээн зөвшөөрөх
        ArgVoid-д хандсанаар эдгээр үйлчилгээний нөхцөлийг зөвшөөрч байна. Хэрэв эдгээр нөхцөлийг зөвшөөрөөгүй бол үйлчилгээг ашиглах ёсгүй.<br><br>

        <strong>2. Платформын хэрэглээ</strong><br>
        ArgVoid болон түүний программуудыг мэдээллийн болон бүтээлч зорилгоор "байгаагаар нь" өгдөг. Үйлчилгээг зөвхөн хууль ёсны зорилгоор ашиглах ёстой.<br><br>

        <strong>3. Хориглосон үйлдэл</strong><br>
        Сайтын эмзэг байдлыг ашиглах, спам илгээх, дэд бүтцэд зөвшөөрөлгүй нэвтрэх оролдлого хийхийг хатуу хориглоно.<br><br>

        <strong>4. Анхааруулга</strong><br>
        Платформ болон үйлчилгээг ямар ч үед мэдэгдэлгүйгээр өөрчилж болно. Үйлчилгээний ажиллах хугацаа болон бэлэн байдлын талаар ямар ч баталгаа өгөхгүй.
    `,
    policy_content: `
        <strong>1. Мэдээллийн цуглуулга</strong><br>
        Энэ платформ нь одоогоор хэрэглэгчийн баталгаажуулалт, бүртгэл үүсгэх шаардлагагүй. Зочдоос хувийн таних мэдээллийг (нэр, имэйл хаяг гэх мэт) идэвхтэй цуглуулдаггүй.<br><br>

        <strong>2. Ашиглалтын Data</strong><br>
        Сайтын урсгалыг ойлгох, програмуудыг сайжруулахын тулд үндсэн, нэрээ нууцалсан аналитикийг цуглуулж болно. Энэ өгөгдөл нь хэрэглэгчийн хувийн мэдээлэлтэй холбоогүй болно.<br><br>

        <strong>3. Гуравдагч талын үйлчилгээ</strong><br>
        Гуравдагч талын үйлчилгээ үзүүлэгчдийг хостинг болон аналитик үйлчилгээнд ашиглаж болно. Эдгээр холбогдох үйлчилгээ үзүүлэгчдийн нууцлалын практик нь тэдний дэд бүтцэд боловсруулсан нэргүй өгөгдлийг зохицуулдаг.<br><br>

        <strong>4. Өгөгдлийн аюулгүй байдал</strong><br>
        Платформыг хамгаалахын тулд аюулгүй байдлын боломжийн арга хэмжээг хэрэгжүүлдэг. Гэсэн хэдий ч интернетээр дамжуулах ямар ч арга бүрэн аюулгүй байдаггүй.<br><br>
    `,
    cookies_content: `
        <strong>1. Cookies болон Local Storage гэж юу вэ? </strong><br>
        Күүки болон хөтчийн дотоод санах ой нь зочилсон хугацаанд тохиргооны тохиргоог санахын тулд төхөөрөмж дээр хадгалагдсан жижиг өгөгдлийн файлууд юм.<br><br>

        <strong>2. Хэрэглээний зорилго</strong><br>
        Browser LocalStorage нь тохиргооны тохиргоог хадгалахад зориулагдсан болно, тухайлбал: <br>
        - Хэлний сонголт<br>
        - Хэрэглэгчийн интерфэйсийн тохиргоо (жишээ нь, байршил эсвэл сэдвийн тохиргоо) <br>
        - Түр зуурын програмын cache<br><br>

        <strong>3. Хяналт байхгүй</strong><br>
        Күүки болон орон нутгийн хадгалах санг зар сурталчилгаа эсвэл гуравдагч этгээдийн мөрдөх зорилгоор ашигладаггүй. Бүх хадгалсан өгөгдөл нь платформын үндсэн функцэд зориулагдсан болно.<br><br>

        <strong>4. Control</strong><br>
        Хөтчийн өгөгдлийг хөтчийн тохиргоогоор дамжуулан хүссэн үедээ цэвэрлэх боломжтой бөгөөд энэ нь ямар ч дотоод тохиргоог дахин тохируулах болно.
    `,
    cookie_consent_text: "Бид таны сессийг идэвхтэй байлгах, таны хэлний тохиргоо болон бусад тохиргоог хадгалах гэх мэт вэбсайтын үйл ажиллагааг зөв хангахын тулд үндсэн күүки ашигладаг.",
    read_policy: "Күүкийн бодлогыг уншина уу",
    support_title: "Дэмжлэгтэй холбоо барина уу",
    support_subject_label: "Сэдэв",
    support_message_label: "Мессеж",
    support_submit_button: "Мессеж илгээх",
    support_hint: "Тайлбар: Энэ нь мессеж илгээхийн тулд таны өгөгдмөл имэйл програмыг нээх болно.",
    support_success_msg: "Таны имэйлийн програмыг нээж байна...",
    support_error_msg: "Мессеж илгээж чадсангүй. Дараа дахин оролдоно уу.",
    explorer_title: "Судлаач",
    history_title: "Түүх",
    animation_title: "Хөдөлгөөнт дүрс",
    config_title: "Тохиргоо",
    tool_mouse: "Сонгох (Ctrl+M)",
    tool_brush: "Сойз (Ctrl+B)",
    tool_brush_mode: "Сэлгэх горим (Цэвэр/Цэвэр)",
    tool_eraser: "Баллуур (Ctrl+E)",
    tool_brush_size: "Сойзны хэмжээг тохируулах",
    tool_bucket: "Бөглөх (Ctrl+F)",
    tool_eyedropper: "Нүдний дусаагуур",
    tool_grid: "Тор (Ctrl+Shift+B)",
    tool_rotate: "Эргүүлэх (Ctrl+Shift+R)",
    tool_flip_h: "H эргүүлэх (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Хөрвүүлэх (Ctrl+Shift+T)",
    label_width: "Өргөн",
    label_height: "Өндөр",
    label_frames: "Хүрээний тоо",
    label_animation: "Хөдөлгөөнт дүрс",
    label_background_color: "Арын өнгө",
    label_interval: "Интервал",
    tool_anim_config: "Анимацын тохиргоо",
    label_new_width: "Шинэ өргөн",
    label_new_height: "Шинэ өндөр",
    label_apply: "Өргөдөл гаргах",
    label_colors: "Өнгө",
    label_size: "Хэмжээ",
    label_tolerance: "Хүлцэл",
    val_horizontal: "Хэвтээ",
    val_vertical: "Босоо",
    val_sequence: "Дараалал",
    val_bounce: "Үсрэх",
    val_random: "Санамсаргүй",
    val_solid: "Хатуу",
    val_clear: "Тодорхой",
    action_add_sheet: "Шинэ хуудас",
    action_import: "Импорт",
    action_export: "Экспорт",
    action_sort_projects: "Эрэмбэлэх",
    sort_date_old: "Хамгийн эртний Эхний",
    sort_date_new: "Хамгийн шинэ Эхний",
    sort_name_az: "Нэр (A-Z)",
    sort_name_za: "Нэр (Z-A)",
    action_new_sprite: "Шинэ Sprite",
    action_new_project: "Шинэ төсөл",
    modal_save_all_title: "Бүх өөрчлөлтийг хадгалах",
    modal_save_all_desc: "Хадгалах хөрөнгийг сонгоно уу:",
    modal_save_selected: "Сонгосоныг хадгалах",
    action_saved: "Хадгалсан",
    modal_create_sprite_title: "Шинэ Sprite үүсгэх",
    modal_create_project_title: "Шинэ төсөл үүсгэх",
    modal_add_sheet_title: "Шинэ хуудас нэмэх",
    modal_rename_sheet_title: "Хуудасны нэрийг өөрчлөх",
    modal_rename_sprite_title: "Sprite-ийн нэрийг өөрчлөх",
    modal_delete_sprite_title: "Sprite устгах",
    modal_delete_project_title: "Төслийг устгах",
    modal_delete_sheet_title: "Хуудас устгах",
    placeholder_sprite_name: "Нэр",
    placeholder_project_name: "Нэр",
    placeholder_sheet_name: "Нэр",
    placeholder_new_name: "Шинэ нэр",
    action_create: "Үүсгэх",
    action_add: "Нэмэх",
    action_rename: "Нэрээ өөрчлөх",
    action_duplicate: "Давхардсан",
    action_delete: "Устгах",
    action_cancel: "Цуцлах",
    confirm_delete_sprite: "Та энэ спрайтыг устгахдаа итгэлтэй байна уу?",
    confirm_delete_project: "Та энэ төслийг устгахдаа итгэлтэй байна уу? Бүх спрайтуудыг устгах болно.",
    confirm_delete_sheet: "Та энэ хуудсыг устгахдаа итгэлтэй байна уу?",
    err_select_sprite: "Эхлээд спрайт сонгоно уу.",
    err_select_project: "Эхлээд төслөө сонгоно уу.",
    err_name_empty: "Нэр хоосон байж болохгүй.",
    err_sprite_exists: "Ийм нэртэй спрайт аль хэдийн байна.",
    err_project_exists: "Ийм нэртэй төсөл аль хэдийн байна.",
    err_no_content: "Хадгалах контент алга.",
    err_no_changes: "Хадгалах өөрчлөлт байхгүй.",
    err_delete_last_sheet: "Сүүлийн хуудсыг устгах боломжгүй.",
    err_extract_frames: "Ямар ч хүрээ гаргаж чадсангүй.",
    err_indexeddb: "Орон нутагт хадгалж чадсангүй. Таны хөтөч IndexedDB-г дэмждэггүй байж магадгүй.",
    msg_upload_success: "Амжилттай байршуулсан: {0}",
    msg_upload_failed: "Байршуулж чадсангүй: {0}",
    msg_save_success: "Амжилттай хадгаллаа.",
    msg_saving: "Хадгалж байна...",
    msg_multi_save_result: "{0} хөрөнгийг хадгалсан. {1} алдаа.",
    menu_title: "Цэс",
    menu_save: "Хадгалах",
    menu_save_all: "Бүгдийг хадгалах",
    menu_support: "Дэмжлэгтэй холбоо барина уу",
    label_local_storage: "Орон нутгийн хадгалах сан",
    label_sign_in: "Нэвтрэх",
    modal_export_title: "Sprite экспортлох",
    label_filename: "Файлын нэр",
    label_format: "Формат",
    action_export_confirm: "Экспорт",
};

export default translations;
